import { QueryFunctionContext } from "react-query";
import { ChangePasswordDetails, UserProfile } from "../types/UserDetailModel";
import optionsApi from "./optionsApi";
import { CustomResponse } from "../types/Grant";
import { PlatformError } from "../types/common";

export async function saveUserProfile(data: UserProfile): Promise<void> {
  return optionsApi.put("/v1/auth/userDetails", data);
}

export async function changePassword(data: ChangePasswordDetails) {
  return optionsApi
    .post("/v1/auth/changePassword", data)
    .then((res) => res.data);
}

export async function getNotifications(): Promise<
  CustomResponse<{ notifications: PlatformError[] }>
> {
  return optionsApi.get("/v1/user/notifications").then((res) => res.data);
}
